import { useEffect } from "react";
import { useMyHrChangeRequestsEnabled } from "my-hr/hooks";
import { useMyNewsEnabled } from "my-news/hooks";
import { useMyTimeUserApprovalState } from "my-time/hooks/use-user-approval-state";
import {
  useOcProperty,
  useOcTwoFactorEnabled,
  useOcTwoFactorEnabledDateState,
  useOcTwoFactorEnabledState,
} from "oc/hooks";

export const useOcInitStates = () => {
  const { state: myNewsEnabled, setState: setMyNewsEnabled } =
    useMyNewsEnabled();
  const { state: changeRequestsEnabled, setState: setChangeRequestsEnabled } =
    useMyHrChangeRequestsEnabled();

  const { state: twoFaEnabled, setState: setTwoFaEnabled } =
    useOcTwoFactorEnabledState();

  const { state: twoFaEnabledDate, setState: setTwoFaEnabledDate } =
    useOcTwoFactorEnabledDateState();

  const { state: userApprovalEnabled, setState: setUserApprovalEnabled } =
    useMyTimeUserApprovalState();

  const parseValue = (value?: string) => {
    return value === "true" ? true : false;
  };

  const { data: myNewsEnabledData } = useOcProperty({
    resource: "myNews",
    key: "myNewsEnabled",
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (myNewsEnabledData !== undefined) {
      const value = parseValue(myNewsEnabledData);
      if (myNewsEnabled !== value) {
        setMyNewsEnabled(value);
      }
    }
  }, [myNewsEnabledData, myNewsEnabled, setMyNewsEnabled]);

  const { data: changeRequestsEnabledData } = useOcProperty({
    resource: "system",
    key: "changeRequestsEnabled",
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (changeRequestsEnabledData !== undefined) {
      const value = parseValue(changeRequestsEnabledData);
      if (changeRequestsEnabled !== value) {
        setChangeRequestsEnabled(value);
      }
    }
  }, [changeRequestsEnabledData, changeRequestsEnabled, setChangeRequestsEnabled]);

  useOcProperty({
    resource: "myDocuments",
    key: "myDocumentsMenuEnabled",
    fetchPolicy: "network-only",
  });

  const { data: twoFaEnabledData, validFrom: twoFaValidFrom } = useOcTwoFactorEnabled({
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (twoFaEnabledData !== undefined) {
      const value = parseValue(twoFaEnabledData);
      if (twoFaEnabled !== value) {
        setTwoFaEnabled(value);
      }
    }
  }, [twoFaEnabledData, twoFaEnabled, setTwoFaEnabled]);

  useEffect(() => {
    if (twoFaValidFrom !== undefined && twoFaEnabledDate !== twoFaValidFrom) {
      setTwoFaEnabledDate(twoFaValidFrom);
    }
  }, [twoFaValidFrom, twoFaEnabledDate, setTwoFaEnabledDate]);

  const { data: userApprovalEnabledData } = useOcProperty({
    resource: "myTime",
    key: "userApprovalEnabled",
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (userApprovalEnabledData !== undefined) {
      const value = parseValue(userApprovalEnabledData);
      if (userApprovalEnabled !== value) {
        setUserApprovalEnabled(value);
      }
    }
  }, [userApprovalEnabledData, userApprovalEnabled, setUserApprovalEnabled]);

  return true;
};

export default useOcInitStates;
